import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { VersionService } from "./version.service";
import { Router } from "@angular/router";
var VersionComponent = (function () {
    function VersionComponent(versionService, differs, toastr, vcr, router) {
        this.versionService = versionService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.app = {};
        this.modal = {};
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    VersionComponent.prototype.ngOnInit = function () {
        this.title = "App information";
        this.filterParams = {
            size: 10,
            page: 0
        };
    };
    VersionComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getAppList();
        }
    };
    VersionComponent.prototype.getAppList = function () {
        var _this = this;
        this.isLoading = true;
        this.versionService.getAppList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.appList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    VersionComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    VersionComponent.prototype.initModal = function (state, app) {
        if (app === void 0) { app = {}; }
        switch (state) {
            case 'create':
                {
                    this.modal = {
                        title: 'Create app',
                        btnName: 'Create',
                        state: state
                    };
                    this.app = {};
                }
                break;
            case 'edit':
                {
                    this.modal = {
                        title: 'Edit app',
                        btnName: 'Save',
                        state: state
                    };
                    this.app = app;
                }
                break;
        }
        $('#myModal').modal('show');
    };
    VersionComponent.prototype.onSubmit = function (frmAppInfo) {
        var _this = this;
        this.isLoading = true;
        if (this.modal.state === 'create') {
            this.versionService.createApp(frmAppInfo.value)
                .then(function (res) {
                if (res.status === 1) {
                    _this.toastr.success(res.message, 'Success!');
                    _this.getAppList();
                    $('#myModal').modal('hide');
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
                _this.isLoading = false;
            })
                .catch(function (err) { return console.log(err); });
        }
        if (this.modal.state === 'edit') {
            this.versionService.editApp(frmAppInfo.value)
                .then(function (res) {
                if (res.status === 1) {
                    _this.toastr.success(res.data, 'Success!');
                    _this.getAppList();
                    $('#myModal').modal('hide');
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
                _this.isLoading = false;
            })
                .catch(function (err) { return console.log(err); });
        }
    };
    VersionComponent.prototype.deleteApp = function (id) {
        var _this = this;
        if (confirm("Confirm delete!")) {
            this.versionService.deleteApp(id)
                .then(function (res) {
                if (res.status == 1) {
                    _this.toastr.success(res.data, 'Success!');
                    _this.getAppList();
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
            }).catch(function (err) { return console.log(err); });
        }
    };
    return VersionComponent;
}());
export { VersionComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/version/version.component.ts.pre-build-optimizer.js